import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { STRIPE_PUBLISHABLE_KEY, STRIPE_PUBLISHABLE_KEY_UK } from "@constant";
import CheckoutForm from "@stripecheckout";

const Stripe = (props) => {
  const { onlinePaymentKeys, otherprops } = props;
  // console.log("stripe props :- ", props);
  let billingAccountInfo = otherprops.billingaccount;
  // console.log("billingAccountInfo :- ", billingAccountInfo);
  let stripeBillingAccount = billingAccountInfo?.stripe ?? "AU";
  let PK =
    stripeBillingAccount === "UK"
      ? STRIPE_PUBLISHABLE_KEY_UK
      : STRIPE_PUBLISHABLE_KEY;

  const stripePromise = loadStripe(PK, {
    stripeAccount: props?.stripeAccountId,
  });

  const options = {
    clientSecret: onlinePaymentKeys.secret,
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      <CheckoutForm {...props} />
    </Elements>
  );
};

const mapStateToProps = (state) => ({
  session: state.session,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Stripe);
